<template>
	<div ref="bmodal" v-if="modelValue">
		<Transition>
			<section class="fixed top-0 left-0 grid place-items-center h-screen w-screen bg-black bg-opacity-25 z-50">
				<div
					:class="otherModalClasses"
					class="flex flex-col min-w-[40vw] max-w-screen-sm min-h-max border border-dj-gray-light rounded-normal bg-white"
				>
					<header class="flex mb-4 px-dj-40 pt-7">
						<h1 class="text-xl">{{ title }}</h1>
						<span
							v-if="showCloseButton"
							class="material-icons-outlined -mt-2 ml-auto -mr-3 text-dj-gray cursor-pointer items-start"
							@click="closeSelf"
						>
							close
						</span>
					</header>
					<div class="px-dj-40 mb-5">
						<slot></slot>
					</div>
					<div v-if="footer" class="flex border-t pb-dj-24 text-dj-gray">
						<div class="flex items-center w-full pt-dj-24">
							<div @click="closeSelf" class="flex items-center ml-dj-40 cursor-pointer">
								<slot name="custom-button"></slot>
							</div>
							<div class="flex space-x-4 ml-auto mr-dj-40">
								<BaseButton type="tertiary" @click="onCancel">{{ cancelText }}</BaseButton>
								<BaseButton @click="onAccept">{{ acceptText }}</BaseButton>
							</div>
						</div>
					</div>
				</div>
			</section>
		</Transition>
	</div>
</template>

<script lang="ts">
import BaseButton from "~/ui-kit/components/BaseButton.vue";
import { defineComponent, onUpdated } from "vue";
import { useScrollLock } from "@vueuse/core";

export default defineComponent({
	name: "BaseModal",
	components: { BaseButton },
	props: {
		modelValue: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: "Modal title",
		},
		cancelText: {
			type: String,
			default: "Cancel",
		},
		acceptText: {
			type: String,
			default: "Accept",
		},
		showCloseButton: {
			type: Boolean,
			default: true,
		},
		footer: {
			type: Boolean,
			default: false,
		},
		otherModalClasses: {
			type: String,
			default: "bg-white",
		},
	},
	emits: ["update:modelValue", "onCancel", "onAccept"],
	setup(props, { emit }) {
		const body = document.body;
		const isLocked = useScrollLock(body);

		onUpdated(() => {
			if (props.modelValue) isLocked.value = true;
			else isLocked.value = false;
		});

		function closeSelf() {
			emit("update:modelValue", false);
		}

		function onAccept() {
			emit("onAccept");
			closeSelf();
		}

		function onCancel() {
			emit("onCancel");
			closeSelf();
		}

		return {
			closeSelf,
			onAccept,
			onCancel,
		};
	},
});
</script>
